// extracted by mini-css-extract-plugin
export default {"commentsFeed":"CommentFeed_commentsFeed__Dh8Mx","showMore":"CommentFeed_showMore__znfvR"};